import { Alert, Col, Flex, List, Row, Segmented, Table, Tag } from "antd";
import React, { useMemo, useState, memo } from "react";
import { CustomParagraph, CustomTitle } from "../../../components";
import TimesTable from "../../../components/TimesTable";
import { WarningIcon } from "../../../assets/icons/icons";
import UATimesTable from "../../../components/UATimesTable";

const hoursData = [
  { day: "Monday", time: "3:00 AM - 10:30 PM" },
  { day: "Tuesday", time: "3:00 AM - 10:30 PM" },
  { day: "Wednesday", time: "3:00 AM - 10:30 PM" },
  { day: "Thursday", time: "3:00 AM - 10:30 PM" },
  { day: "Friday", time: "3:00 AM - 10:30 PM" },
  { day: "Saturday", time: "3:00 AM - 10:30 PM" },
  { day: "Sunday", time: "6:00 AM - 10:30 PM" },
];

const UATabsContent = memo(({ data, address }) => {
  const [selectedTab, setSelectedTab] = useState("dropoff");

  const columns = [
    {
      title: "",
      dataIndex: "day",
      key: "day",
      render: (text) => <span style={{ fontWeight: 500 }}>{text}</span>,
    },
    {
      title: "",
      dataIndex: "hours",
      key: "hours",
      align: "right",
    },
  ];

  const fullDayNames = {
    "Mon.": "Monday",
    "Tue.": "Tuesday",
    "Wed.": "Wednesday",
    "Thu.": "Thursday",
    "Fri.": "Friday",
    "Sat.": "Saturday",
    "Sun.": "Sunday",
  };

  const dataSource = useMemo(() => {
    const operatingHours = data?.operatingHours;
    if (!operatingHours || !operatingHours.days?.length) return [];

    return operatingHours.days.map((day, index) => ({
      key: `day-${index}`,
      day: fullDayNames[day] || day, // Map short name to full day name
      hours: operatingHours.times?.[index] || "N/A",
    }));
  }, [data?.operatingHours]);

  return (
    <div className="zl-tabs-content">
      <Flex vertical gap={28}>
        <Flex vertical gap={4}>
          <CustomTitle
            className="zl-custom-title-sm"
            text={data?.name}
            fontSize="20px"
            fontWeight="700"
            lineHeight="24px"
            color="black"
          />
          <div style={{ maxWidth: "180px" }}>
            <CustomTitle
              text={data?.facilityAddress}
              fontSize="12px"
              fontWeight="400"
              lineHeight="20px"
              color="black"
              marginBottom="0"
              marginTop="0"
            />
          </div>
        </Flex>
        <Flex vertical gap={12}>
          <Flex gap={10} justify="space-between">
            <CustomTitle
              text="Operating hours"
              fontSize="16px"
              fontWeight="600"
              lineHeight="20px"
              color="black"
              marginBottom="0"
              marginTop="0"
            />
            <Tag className="zl-custom-success-tag">Open now</Tag>
          </Flex>

          <Table
             className="zl-custom-times-table"
            columns={columns}
            dataSource={dataSource}
            pagination={false}
            showHeader={false}
            bordered
            size="middle"
            style={{ borderRadius: "8px" }}
          />

          {/* <List
            className="zl-opening-hours-list"
            bordered
            dataSource={hoursData}
            renderItem={(item) => (
              <List.Item>
                <Flex
                  align="center"
                  justify="space-between"
                  style={{ width: "100%" }}
                >
                  <span className="list-item">{item.day}</span>
                  <time className="list-item">{item.time}</time>
                </Flex>
              </List.Item>
            )}
          />   */}
        </Flex>
        <Flex gap={10} align="center" justify="space-between" wrap>
          <CustomTitle
            text="Minimum times"
            fontSize="16px"
            fontWeight="600"
            lineHeight="20px"
            color="black"
            marginBottom="0"
          />
          <Segmented
            className="zl-custom-segmented"
            value={selectedTab}
            onChange={setSelectedTab}
            options={[
              { label: "Dropoff", value: "dropoff" },
              { label: "Pickup", value: "pickup" },
            ]}
          />
        </Flex>
        <UATimesTable
          data={selectedTab == "dropoff" ? data?.dropOffTime : data?.pickupTime}
          selectedTab={selectedTab}
        />
        {/* contact info  */}

        <div>
          <CustomTitle
            text="Contact Info"
            fontSize="16px"
            fontWeight="600"
            lineHeight="20px"
            color="black"
            marginBottom="12px"
            marginTop="0"
          />
          <Row>
            <Col span={24}>
              <Flex vertical gap={16} className="zl-summary-detail">
                <Flex
                  vertical
                  gap={12}
                  className="zl-company-info"
                  style={{ padding: "16px" }}
                >
                  <Flex gap={24}>
                    {/* email  */}
                    <Flex vertical gap={4} style={{ flex: "1" }}>
                      <CustomTitle
                        text="Email"
                        fontSize="12px"
                        fontWeight="600"
                        lineHeight="16px"
                        color="black"
                        marginBottom="0"
                        marginTop="0"
                      />
                      <CustomTitle
                        text={data?.contactInfo?.Email || "--"}
                        fontSize="12px"
                        fontWeight="400"
                        lineHeight="20px"
                        color="#4B4B4B"
                        marginBottom="0"
                        marginTop="0"
                      />
                    </Flex>
                    {/* sales email  */}
                    <Flex vertical gap={4} style={{ flex: "1" }}>
                      <CustomTitle
                        text="Sales email"
                        fontSize="12px"
                        fontWeight="600"
                        lineHeight="16px"
                        color="black"
                        marginBottom="0"
                        marginTop="0"
                      />
                      <CustomTitle
                        text={data?.contactInfo?.Sales_Email || data?.contactInfo?.Sales_email || "--"}
                        fontSize="12px"
                        fontWeight="400"
                        lineHeight="20px"
                        color="#4B4B4B"
                        marginBottom="0"
                        marginTop="0"
                      />
                    </Flex>
                    {/* phone 1 */}
                    <Flex vertical gap={4} style={{ flex: "1" }}>
                      <CustomTitle
                        text="Phone 1"
                        fontSize="12px"
                        fontWeight="600"
                        lineHeight="16px"
                        color="black"
                        marginBottom="0"
                        marginTop="0"
                      />
                      <CustomTitle
                        text={
                          data?.contactInfo?.Import_Phone ||
                          data?.contactInfo?.Phone ||
                          "--"
                        }
                        fontSize="12px"
                        fontWeight="400"
                        lineHeight="20px"
                        color="#4B4B4B"
                        marginBottom="0"
                        marginTop="0"
                      />
                    </Flex>
                    {/* phone 2 */}
                    <Flex vertical gap={4} style={{ flex: "1" }}>
                      <CustomTitle
                        text="Phone 2"
                        fontSize="12px"
                        fontWeight="600"
                        lineHeight="16px"
                        color="black"
                        marginBottom="0"
                        marginTop="0"
                      />
                      <CustomTitle
                        text={
                          data?.contactInfo?.Export_Phone ||
                          data?.contactInfo?.Sales_Phone ||
                          "--"
                        }
                        fontSize="12px"
                        fontWeight="400"
                        lineHeight="20px"
                        color="#4B4B4B"
                        marginBottom="0"
                        marginTop="0"
                      />
                    </Flex>
                  </Flex>
                  {/* Firms code  */}
                  <Flex gap={24}>
                    {/* Firms code  */}
                    <Flex vertical gap={4} style={{ flex: "1" }}>
                      <CustomTitle
                        text="Firms code"
                        fontSize="12px"
                        fontWeight="600"
                        lineHeight="16px"
                        color="black"
                        marginBottom="0"
                        marginTop="0"
                      />
                      <CustomTitle
                        text={data?.contactInfo?.FIRMS_Code || "--"}
                        fontSize="12px"
                        fontWeight="400"
                        lineHeight="20px"
                        color="#4B4B4B"
                        marginBottom="0"
                        marginTop="0"
                      />
                    </Flex>
                  </Flex>
                </Flex>
              </Flex>
            </Col>
          </Row>
        </div>

        {/* exceptions */}
        {data?.exceptions?.length > 0 && (
          <div>
            <CustomTitle
              text="Exceptions"
              fontSize="16px"
              fontWeight="600"
              lineHeight="20px"
              color="black"
              marginBottom="12px"
              marginTop="0"
            />
            <Row>
              <Col span={24}>
                <Flex vertical gap={16} className="zl-summary-detail">
                  <Flex
                    vertical
                    gap={12}
                    className="zl-company-info"
                    style={{ padding: "16px" }}
                  >
                    {data?.exceptions?.map((item, index) => (
                      <CustomParagraph
                        text={item}
                        color="#000"
                        fontSize="12px"
                        fontWeight="400"
                        lineHeight="20px"
                        marginBottom={12}
                      />
                    ))}
                  </Flex>
                </Flex>
              </Col>
            </Row>
          </div>
        )}
      </Flex>
    </div>
  );
});

export default UATabsContent;
